import { IS_APP_VISIBLE_STORAGE_KEY } from '@/constants/common'

export const visibilityChangeHandler = () => {
  const newVisibility = !document.hidden
  localStorage.setItem(IS_APP_VISIBLE_STORAGE_KEY, newVisibility.toString())
}

export const focusHandler = () => {
  localStorage.setItem(IS_APP_VISIBLE_STORAGE_KEY, 'true')
}

export const blurHandler = () => {
  localStorage.setItem(IS_APP_VISIBLE_STORAGE_KEY, 'false')
}
